import { render } from "./S915_BenutzerSuche.vue?vue&type=template&id=21c61083&scoped=true&ts=true"
import script from "./S915_BenutzerSuche.vue?vue&type=script&lang=ts"
export * from "./S915_BenutzerSuche.vue?vue&type=script&lang=ts"

import "./S915_BenutzerSuche.vue?vue&type=style&index=0&id=21c61083&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c61083"]])

export default __exports__